<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/company" />
          <div class="newsWrapcontent">
            <div class="newsWrap">
              <div class="newslist01" v-if="data.length > 0">
                <dl class="clearfix" v-for="(item,index) in data" :key="index">
                  <dt>
                    <router-link :to="item.src"><img :src="baseApi + item.image" /> </router-link>
                  </dt>
                  <dd>
                    <h3><router-link :to="item.src">{{item.title}}</router-link></h3>
                    <p class="time">{{item.date}}</p>
                    <p class="Description">
                      <router-link :to="item.src">{{item.content}}</router-link>
                    </p>
                    <p class="more"><router-link :to="item.src">查看详情</router-link></p>
                  </dd>
                </dl>
              </div>
              <div style="padding: 50px; text-align: center" v-else>建设中...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/news/componets/Banner'
import Tab from '@/views/news/componets/Tab'
import axios from 'axios'
// import axios from 'axios'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/',
      data: []
    }
  },
  mounted () {
    axios({
      method: 'get',
      url: process.env.API_ROOT + 'static/news.json'
    })
      .then(response => {
        this.data = response.data.filter(m => m.type === 1)
      }).catch(reason => {
        console.log(reason)
      })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/company.vue